export default "__VITE_ASSET__BYeEqTFj__"